import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/Imagotipo.svg'


const _withScopeId = n => (_pushScopeId("data-v-e9977584"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "nav" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "logo",
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_3 = { id: "nav-links" }
const _hoisted_4 = { class: "menu-item" }
const _hoisted_5 = ["href", "onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M7.5,3.744a3,3,0,0,1,4.992,0l4.394,6.592A3,3,0,0,1,14.394,15H5.606a3,3,0,0,1-2.5-4.664Z",
  transform: "translate(15) rotate(90)"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "menu-item" }
const _hoisted_9 = ["href", "onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M7.5,3.744a3,3,0,0,1,4.992,0l4.394,6.592A3,3,0,0,1,14.394,15H5.606a3,3,0,0,1-2.5-4.664Z",
  transform: "translate(15) rotate(90)"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "menu-item" }
const _hoisted_13 = ["href", "onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M7.5,3.744a3,3,0,0,1,4.992,0l4.394,6.592A3,3,0,0,1,14.394,15H5.606a3,3,0,0,1-2.5-4.664Z",
  transform: "translate(15) rotate(90)"
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "menu-item" }
const _hoisted_17 = ["href", "onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M7.5,3.744a3,3,0,0,1,4.992,0l4.394,6.592A3,3,0,0,1,14.394,15H5.606a3,3,0,0,1-2.5-4.664Z",
  transform: "translate(15) rotate(90)"
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "menu-item" }
const _hoisted_21 = ["href", "onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M7.5,3.744a3,3,0,0,1,4.992,0l4.394,6.592A3,3,0,0,1,14.394,15H5.606a3,3,0,0,1-2.5-4.664Z",
  transform: "translate(15) rotate(90)"
}, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { id: "hamburguer" }
const _hoisted_25 = { id: "nav-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_mobile_menu = _resolveComponent("mobile-menu")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            custom: ""
          }, {
            default: _withCtx(({
                            href,
                            route,
                            navigate,
                            isActive,
                            isExactActive,
                        }) => [
              _createElementVNode("a", {
                class: _normalizeClass([
                                'menu-link',
                                isActive && 'router-link-active',
                                isExactActive && 'router-link-exact-active',
                            ]),
                href: href,
                onClick: navigate
              }, _toDisplayString(route.name), 11, _hoisted_5),
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass([
                                'item-decoration',
                                isActive && 'router-link-active',
                                isExactActive && 'router-link-exact-active',
                            ]),
                xmlns: "http://www.w3.org/2000/svg",
                width: "10",
                height: "15",
                viewBox: "0 0 15 20"
              }, _hoisted_7, 2))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_8, [
          _createVNode(_component_router_link, {
            to: "/noticias",
            custom: ""
          }, {
            default: _withCtx(({
                            href,
                            route,
                            navigate,
                            isActive,
                            isExactActive,
                        }) => [
              _createElementVNode("a", {
                class: _normalizeClass([
                                'menu-link',
                                isActive && 'router-link-active',
                                isExactActive && 'router-link-exact-active',
                            ]),
                href: href,
                onClick: navigate
              }, _toDisplayString(route.name), 11, _hoisted_9),
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass([
                                'item-decoration',
                                isActive && 'router-link-active',
                                isExactActive && 'router-link-exact-active',
                            ]),
                xmlns: "http://www.w3.org/2000/svg",
                width: "10",
                height: "15",
                viewBox: "0 0 15 20"
              }, _hoisted_11, 2))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_12, [
          _createVNode(_component_router_link, {
            to: "/transparencia",
            custom: ""
          }, {
            default: _withCtx(({
                            href,
                            route,
                            navigate,
                            isActive,
                            isExactActive,
                        }) => [
              _createElementVNode("a", {
                class: _normalizeClass([
                                'menu-link',
                                isActive && 'router-link-active',
                                isExactActive && 'router-link-exact-active',
                            ]),
                href: href,
                onClick: navigate
              }, _toDisplayString(route.name), 11, _hoisted_13),
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass([
                                'item-decoration',
                                isActive && 'router-link-active',
                                isExactActive && 'router-link-exact-active',
                            ]),
                xmlns: "http://www.w3.org/2000/svg",
                width: "10",
                height: "15",
                viewBox: "0 0 15 20"
              }, _hoisted_15, 2))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_16, [
          _createVNode(_component_router_link, {
            to: "/contacto",
            custom: ""
          }, {
            default: _withCtx(({
                            href,
                            route,
                            navigate,
                            isActive,
                            isExactActive,
                        }) => [
              _createElementVNode("a", {
                class: _normalizeClass([
                                'menu-link',
                                isActive && 'router-link-active',
                                isExactActive && 'router-link-exact-active',
                            ]),
                href: href,
                onClick: navigate
              }, _toDisplayString(route.name), 11, _hoisted_17),
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass([
                                'item-decoration',
                                isActive && 'router-link-active',
                                isExactActive && 'router-link-exact-active',
                            ]),
                xmlns: "http://www.w3.org/2000/svg",
                width: "10",
                height: "15",
                viewBox: "0 0 15 20"
              }, _hoisted_19, 2))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_20, [
          _createVNode(_component_router_link, {
            to: "/covid-19",
            custom: ""
          }, {
            default: _withCtx(({
                            href,
                            route,
                            navigate,
                            isActive,
                            isExactActive,
                        }) => [
              _createElementVNode("a", {
                class: _normalizeClass([
                                'menu-link',
                                isActive && 'router-link-active',
                                isExactActive && 'router-link-exact-active',
                            ]),
                href: href,
                onClick: navigate
              }, _toDisplayString(route.name), 11, _hoisted_21),
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass([
                                'item-decoration',
                                isActive && 'router-link-active',
                                isExactActive && 'router-link-exact-active',
                            ]),
                xmlns: "http://www.w3.org/2000/svg",
                width: "10",
                height: "15",
                viewBox: "0 0 15 20"
              }, _hoisted_23, 2))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createVNode(_component_mobile_menu)
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("h5", null, _toDisplayString(_ctx.bottomMessage), 1)
    ])
  ]))
}